/* eslint-disable */
export default {
  data() {
    return {
    }
  },
  methods: {
    getAllegato: function (doc) {
      if (doc.container !== undefined && doc.container !== '') {
        this.downloadDoc(doc)
      } else {
        let win = window.open(doc.link, '_blank')
        win.focus()
      }
    },
    downloadDoc: function (doc) {
      console.log("downloadDoc.js - downloadDoc: " + process.env.APP_ENV)
      let win = window.open('', '_blank')
      if (['dev', 'qa'].includes(process.env.APP_ENV)) {
        win.location.href = 'https://secureq.rivagroup.com/DocumentiTest/RivaAcciaio_Letterhead.pdf'
        win.focus()
        return
      }
      this.$http.get('portale/' + this.$store.state.country + '/getTokenDoc').then(response => {
        if (response.body.wsToken) {
          let keydoc = encodeURIComponent(doc.keyDoc)
          let url = ('download/cm/' + keydoc + '?keyDoc=' + keydoc + '&container=' + doc.container +
            '&token=' + response.body.wsToken)
          // let win = window.open(process.env.baseUrl + url, '_blank')
          win.location.href = process.env.baseUrlSpring + url
          win.focus()
        } else {
          this.$message({
            showClose: true,
            message: 'Error creating token',
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    getDoc: function (doc) {
      console.log("downloadDoc.js - getDoc: " + process.env.APP_ENV)
      if (['dev', 'qa'].includes(process.env.APP_ENV)) {
        let win = window.open('', '_blank')
        win.location.href = 'https://secureq.rivagroup.com/DocumentiTest/RivaAcciaio_Letterhead.pdf'
        win.focus()
        return
      }
      if (doc.container === undefined) {
        let win = window.open('', '_blank')
        this.$http.get('portale/' + this.$store.state.country + '/getTokenDoc').then(response => {
          if (response.body.wsToken) {
            let filename = doc.nomeFile
            let url = ('download/getDocMod/' + filename + '?token=' +
              response.body.wsToken)
            // let win = window.open(process.env.baseUrl + url, '_blank')
            win.location.href = process.env.baseUrlSpring + url
            win.focus()
          } else {
            this.$message({
              showClose: true,
              message: 'Error creating token',
              type: 'error',
              duration: process.env.duration
            })
          }
        })
      } else {
        let keydoc = encodeURIComponent(doc.keydoc)
        let nome = ''
        // if (!this.browserVersion()) {
        //  nome = this.getNome(doc)
        // }
        let win = window.open('', '_blank')
        this.$http.get('portale/' + this.$store.state.country + '/getTokenDoc').then(response => {
          if (response.body.wsToken) {
            let url = ('download/cm?keyDoc=' + keydoc + '&container=' + doc.container + '&nameDoc=' + nome +
              '&token=' + response.body.wsToken)
            // let win = window.open(process.env.baseUrl + url, '_blank')
            win.location.href = process.env.baseUrlSpring + url
            win.focus()
            return true
          } else {
            this.$message({
              showClose: true,
              message: 'Error creating token',
              type: 'error',
              duration: process.env.duration
            })
            return false
          }
        })
      }
    },
    browserVersion: function () {
      var ua = window.navigator.userAgent
      var msie = ua.indexOf('MSIE ')
      // eslint-disable-next-line no-useless-escape
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        // If Internet Explorer, return version number
        return true
      } else {
        // If another browser, return 0
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/mixins/downloadDoc.js